import React, { useEffect, useState, useContext } from "react";
import { Spinner } from "reactstrap";
import LocationCard from "./LocationCard.js";
import ValetApi from "../api/Api.js";
import UserContext from "../auth/UserContext.js";

const UserLocationDetail = () => {
    const { userDetail } = useContext(UserContext);
    const [location, setLocation] = useState(null);
    const [podiums, setPodiums] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLocation = async () => {
            if (!userDetail?.podiumId) {
                setLoading(false);
                return;
            }
            try {
                const podiumRes = await ValetApi.getPodiumById(userDetail.podiumId);
                const podiumsRes = await ValetApi.getPodiumsByLocationId(podiumRes?.locationId || podiumRes?.data?.podium?.locationId);
                const locationId = podiumRes?.locationId || podiumRes?.data?.podium?.locationId;

                if (!locationId) {
                    setLoading(false);
                    return;
                }

                const locationRes = await ValetApi.getLocationById(locationId);
                setLocation(locationRes?.data?.location || locationRes?.location || locationRes);
                setPodiums(podiumsRes?.data?.podiums || podiumsRes?.podiums || podiums || []);
            } catch (err) {
                setLocation(null);
            } finally {
                setLoading(false);
            }
        };
        fetchLocation();
    }, [userDetail]);

    if (loading) {
        return (
            <Spinner
                color="primary"
                style={{ width: `100%` }}
            />
        );
    }
    if (!location) {
        return <div>No location found.</div>;
    }
    return (
        <div>
            <LocationCard
                location={location}
                podiums={podiums}
            />
        </div>
    );
};

export default UserLocationDetail;
